import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useTranslation } from 'react-i18next';
import { ChatbotConfigWrapper } from "@/components/business/features/communication/components/ChatbotConfigWrapper";
import { Bot, Globe } from "lucide-react";
import { DashboardHeader, AIProviderStatus } from "./components/status";
import { WebIntegrationHub } from "./components/integration";

export function CommunicationDashboard() {
  const { t } = useTranslation('business', { keyPrefix: 'communication' });
  const [activeTab, setActiveTab] = useState('chatbot');
  
  return (
    <div className="space-y-8">
      {/* Header Section */}
      <DashboardHeader />

      {/* Tabbed Interface */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="chatbot" className="gap-2">
            <Bot className="w-4 h-4" />
            Chatbot Settings
          </TabsTrigger>
          <TabsTrigger value="integration" className="gap-2">
            <Globe className="w-4 h-4" />
            Website Integration
          </TabsTrigger>
        </TabsList>

        <TabsContent value="chatbot" className="space-y-6 mt-6">
          {/* AI Provider Status Card */}
          {/* <AIProviderStatus /> */}

          {/* Main Configuration Card */}
          <Card className="border border-slate-200/60 shadow-lg shadow-slate-900/8 bg-white overflow-hidden hover:shadow-xl hover:shadow-slate-900/12 transition-shadow duration-300">
            <CardHeader className="bg-slate-50/80 border-b border-slate-200/50">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg shadow-blue-500/25">
                  <Bot className="w-6 h-6 text-white" />
                </div>
                <div>
                  <CardTitle className="text-xl font-semibold text-slate-900">{t('chatbotSettings')}</CardTitle>
                  <CardDescription className="text-slate-600">
                    {t('customizeAIAssistant')}
                  </CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-0">
              <ChatbotConfigWrapper />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="integration" className="space-y-6 mt-6">
          {/* Web Integration Hub */}
          <WebIntegrationHub />
        </TabsContent>
      </Tabs>
    </div>
  );
}